import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import React from "react";
import { Switch } from "react-router-dom";
import { authorizationService } from "services/common-services/authorization-service";
import EmailRemindConfigMaster from "./EmailRemindConfigMaster/EmailRemindConfigMaster";
import {
  EMAIL_REMINDER_CONFIG_DETAIL_ROUTE,
  EMAIL_REMINDER_CONFIG_MASTER_ROUTE,
  EMAIL_REMINDER_CONFIG_PREVIEW_ROUTE,
} from "config/route-consts";
import EmailRemindConfigDetail from "./EmailRemindConfigDetail/EmailRemindConfigDetail";
import EmailRemindConfigPreview from "./EmailRemindConfigPreview/EmailRemindConfigPreview";

function EmailRemindConfigView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={EMAIL_REMINDER_CONFIG_MASTER_ROUTE}
        key={EMAIL_REMINDER_CONFIG_MASTER_ROUTE}
        component={EmailRemindConfigMaster}
        auth={auth(EMAIL_REMINDER_CONFIG_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={EMAIL_REMINDER_CONFIG_DETAIL_ROUTE}
        key={EMAIL_REMINDER_CONFIG_DETAIL_ROUTE}
        component={EmailRemindConfigDetail}
        auth={auth(EMAIL_REMINDER_CONFIG_DETAIL_ROUTE)}
      />
      <ProtectedRoute
        path={EMAIL_REMINDER_CONFIG_PREVIEW_ROUTE}
        key={EMAIL_REMINDER_CONFIG_PREVIEW_ROUTE}
        component={EmailRemindConfigPreview}
        auth={auth(EMAIL_REMINDER_CONFIG_PREVIEW_ROUTE)}
      />
    </Switch>
  );
}

export { EmailRemindConfigMaster, EmailRemindConfigDetail };
export default EmailRemindConfigView;
